<template>
  <div style="padding: 20px;">
    <!-- 查询区 -->
    <div>
      <el-select
        v-model="params.department_id"
        filterable
        placeholder="请选择部门"
        @change="handleDepartmentChange"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <el-select
        v-model="params.pitcher_id"
        :disabled="!params.department_id"
        filterable
        placeholder="请选择投手"
        style="margin-left: 20px;"
      >
        <el-option
          v-for="item in optionstwo"
          :key="item.id"
          :label="item.admin_name"
          :value="item.id"
        />
      </el-select>

      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 300px; margin-left: 20px;"
        @change="handleDateChange"
      />

      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>

      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>

    <!-- 汇总 -->
    <el-card shadow="never" class="summary-card">
      <div class="summary-container">
        <div v-for="(label, key) in summaryMap" :key="key" class="summary-item">
          <div class="summary-label">{{ label }}</div>
          <div class="summary-value">{{ reportData[key] || 0 }}</div>
        </div>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 20px;"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="department_name" label="部门名称" width="120" align="center" />
      <el-table-column prop="pitcher_id" label="投手ID" width="90" align="center" />
      <el-table-column prop="pitcher_name" label="投手名称" width="100" align="center" />

      <el-table-column prop="total_cost" label="消耗" align="center" sortable="custom" />
      <el-table-column prop="total_income" label="回收" align="center" sortable="custom" />
      <el-table-column prop="total_rebate_income" label="扣点回收" align="center" sortable="custom" />
      <el-table-column prop="profit" label="利润" align="center" sortable="custom" />
      <el-table-column prop="rebate_profit" label="扣点利润" align="center" sortable="custom" />
      <el-table-column prop="total_roi" label="ROI" align="center" sortable="custom" />
      <el-table-column prop="total_rebate_roi" label="回收ROI" align="center" sortable="custom" />
    </el-table>

    <pagination-right
      :current-page="params.page"
      :page-sizes="[10]"
      :total="total"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  iaaMaterialReportdepartmentlist,
  iaapitcherindex,
  reportpitcherEarningsRank
} from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      options: [],
      optionstwo: [],

      params: {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        start_time: '',
        end_time: ''
      },

      dateRange: [],
      tableData: [],
      total: 0,
      reportData: {},

      // 🔑 唯一排序参数
      order_by: null,

      summaryMap: {
        profit: '利润',
        rebate_profit: '扣点利润',
        total_cost: '总消耗',
        total_income: '总回收',
        total_rebate_income: '总扣点回收',
        total_roi: '总回收 ROI',
        total_rebate_roi: '总回收扣点 ROI'
      }
    }
  },

  created() {
    this.fetchDepartments()
    this.getList()
  },

  methods: {
    /* 部门 */
    fetchDepartments() {
      iaaMaterialReportdepartmentlist({ page: 1, page_size: 100 }).then(res => {
        this.options = res.data.list || []
      })
    },

    handleDepartmentChange() {
      this.params.pitcher_id = ''
      this.optionstwo = []
      iaapitcherindex({
        page: 1,
        page_size: 100,
        department_id: this.params.department_id
      }).then(res => {
        this.optionstwo = res.data.list || []
      })
    },

    /* 日期 */
    handleDateChange(val) {
      if (val?.length === 2) {
        this.params.start_time = val[0]
        this.params.end_time = val[1]
      } else {
        this.params.start_time = ''
        this.params.end_time = ''
      }
    },

    /* 排序（唯一入口） */
    handleSortChange({ prop, order }) {
      if (!order) {
        this.order_by = null
      } else {
        this.order_by = {
          field: prop,
          order: order === 'ascending' ? 'asc' : 'desc'
        }
      }
      this.params.page = 1
      this.getList()
    },

    /* 查询 */
    search() {
      this.params.page = 1
      this.getList()
    },

    /* 重置 */
    reset() {
      this.params = {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.order_by = null
      this.optionstwo = []
      this.getList()
    },

    /* 分页 */
    fetchCurrentPage(page) {
      this.params.page = page
      this.getList()
    },

    /* 数据 */
    getList() {
      reportpitcherEarningsRank({
        ...this.params,
        order_by: this.order_by
      }).then(res => {
        this.reportData = res.data || {}
        this.tableData = res.data?.list || []
        this.total = res.data?.count || 0
      })
    }
  }
}
</script>

<style scoped>
.summary-card {
  margin: 20px 0;
  background: #f9fafc;
}

.summary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.summary-item {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  padding: 10px 15px;
  text-align: center;
}

.summary-label {
  font-size: 13px;
  color: #909399;
}

.summary-value {
  font-size: 20px;
  font-weight: 600;
  margin-top: 8px;
}
</style>
